import { Navigate } from "react-router-dom";
import { WorkspacePicker } from "../components/WorkspacePicker";
import { useAuth } from "../lib/auth";
import { lastWorkspace, readTokenMap, type WorkspaceSummary } from "../lib/workspaces";

export function WorkspaceSelection() {
  const { workspaces } = useAuth();
  const selectionToken = sessionStorage.getItem("vms_selection_token") ?? undefined;
  const selectionWorkspaces = JSON.parse(
    sessionStorage.getItem("vms_selection_workspaces") || "[]",
  ) as WorkspaceSummary[];
  const available = selectionWorkspaces.length ? selectionWorkspaces : workspaces;
  const hasWorkspaceToken = Object.keys(readTokenMap()).length > 0;

  if (!selectionToken && !hasWorkspaceToken) return <Navigate to="/login" replace />;
  if (available.length === 0) return <Navigate to="/" replace />;

  return <WorkspacePicker workspaces={available} selectionToken={selectionToken} />;
}

export function RootRedirect() {
  const { workspaces } = useAuth();
  const last = lastWorkspace();
  if (last && readTokenMap()[last.id]) {
    return <Navigate to={`/w/${last.slug}/${workspaces.length > 1 ? "all-sites" : "checkins"}`} replace />;
  }
  if (workspaces.length > 1) return <Navigate to="/workspaces" replace />;
  const workspace = workspaces[0];
  if (workspace && readTokenMap()[workspace.id]) return <Navigate to={`/w/${workspace.slug}/checkins`} replace />;
  return <Navigate to="/login" replace />;
}
